export default __webpack_public_path__ + "static/media/09_attic.3f039a0f.png";